import React from 'react'
import { ShareWithoutVersion } from 'modules/versioning'
import { VersionFragment } from '@sketch/gql-types'
import {
  Button,
  ModalInjectedProps,
  FlatButton,
  Tabs,
  Tab,
  TabPanel,
  useModalContext,
} from '@sketch/components'
import LeaveShareModal from 'modules/shares/components/LeaveShareModal/LeaveShareModal'
import { SharingModalHeader } from './SharingModalHeader'
import {
  WorkspaceMembersPanel,
  WorkspaceMembersTitle,
} from './WorkspaceMembersPanel'
import { GuestsTitle, GuestsPanel } from './GuestsPanel'
import { EveryoneTitle, EveryonePanel } from './EveryonePanel'
import {
  StyledModal as Modal,
  StyledTabList as TabList,
} from './SharingModal.styles'

interface SharingModalProps extends ModalInjectedProps {
  share: ShareWithoutVersion
  latestVersion: VersionFragment
}

const SharingModal = ({
  hideModal,
  share,
  latestVersion,
}: SharingModalProps) => {
  const { showModal } = useModalContext()

  const handleOnLeaveDocument = () => {
    showModal(LeaveShareModal, {
      shareIdentifier: share.identifier,
      shareName: share.name,
    })
  }

  return (
    <Modal onCancel={hideModal}>
      <SharingModalHeader share={share} latestVersion={latestVersion} />
      <Modal.Body>
        <Tabs>
          <TabList shouldDrawSeparator>
            <Tab>
              <WorkspaceMembersTitle
                isProjectAvailableToWorkspace={
                  !share.project ||
                  share.project?.workspaceAccessLevel === 'DEFAULT'
                }
              />
            </Tab>
            <Tab>
              <GuestsTitle
                guestsCount={share.memberships?.meta.totalCount ?? 0}
              />
            </Tab>
            <Tab>
              <EveryoneTitle isPublic={share.publicAccessLevel !== 'NONE'} />
            </Tab>
          </TabList>
          <TabPanel>
            <WorkspaceMembersPanel share={share} />
          </TabPanel>
          <TabPanel>
            <GuestsPanel share={share} />
          </TabPanel>
          <TabPanel>
            <EveryonePanel share={share} />
          </TabPanel>
        </Tabs>
      </Modal.Body>
      <Modal.Footer
        leftContent={
          <FlatButton variant="negative" onClick={handleOnLeaveDocument}>
            Leave Document&hellip;
          </FlatButton>
        }
      >
        <Button onClick={hideModal}>Done</Button>
      </Modal.Footer>
    </Modal>
  )
}

export { SharingModal as default }
